const RightIcon = () => {
    return (
        <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
            <foreignObject x="-27.5" y="-27.5" width="99" height="99">
                <div
                    style={{
                        backdropFilter: 'blur(13.75px)',
                        clipPath: 'url(#bgblur_0_1292_12567_clip_path)',
                        height: '100%',
                        width: '100%',
                    }}
                ></div>
            </foreignObject>
            <path
                data-figma-bg-blur-radius="27.5"
                d="M0 22C0 9.84974 9.84974 0 22 0C34.1503 0 44 9.84974 44 22C44 34.1503 34.1503 44 22 44C9.84974 44 0 34.1503 0 22Z"
                fill="black"
                fillOpacity="0.2"
            />
            <path
                d="M19.5836 28.1696L25.0931 22.66C25.2721 22.481 25.2721 22.1908 25.0931 22.0118L19.5836 16.5023"
                stroke="white"
                strokeWidth="1.83333"
                strokeLinecap="round"
            />
            <defs>
                <clipPath id="bgblur_0_1292_12567_clip_path" transform="translate(27.5 27.5)">
                    <path d="M0 22C0 9.84974 9.84974 0 22 0C34.1503 0 44 9.84974 44 22C44 34.1503 34.1503 44 22 44C9.84974 44 0 34.1503 0 22Z" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default RightIcon;
